// 全ページ共通：ページ内スムーススクロール / グローバルナビ開閉 / スクロール追従ヘッダー

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  // ページ内リンクのスムーススクロール
  const scrollToTarget = (target) => {
    const el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    const top = el === body ? 0 : el.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  body.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const [path, hash] = a.getAttribute('href').split('#');
    if ((path === '' || path === location.pathname) && hash) {
      e.preventDefault();
      scrollToTarget('#' + hash);
    }
  });

  // グローバルナビ（SP）開閉
  body.addEventListener('click', (e) => {
    if (e.target.closest('#gnav_btn')) {
      body.classList.add('gnav_opened');
    } else if (e.target.closest('#gnav_close')) {
      body.classList.remove('gnav_opened');
    } else if (e.target.id === 'gnav_content') {
      body.classList.remove('gnav_opened');
    }
  });

  // ロード時、URL にハッシュがあればそこへスクロール
  window.addEventListener('load', () => {
    if (location.hash) scrollToTarget(location.hash);
  });

  // スクロール追従ヘッダー（上スクロールで表示／下で隠す）
  // ref: https://osvaldas.info/auto-hide-sticky-header
  const element = document.querySelector('nav.header');
  if (element) {
    let wScrollBefore = 0;
    window.addEventListener('scroll', () => {
      const elHeight = element.offsetHeight;
      const wScrollCurrent = window.pageYOffset;
      const wScrollDiff = wScrollBefore - wScrollCurrent;
      const elTop = parseInt(window.getComputedStyle(element).getPropertyValue('top'), 10) + wScrollDiff;
      if (wScrollCurrent <= 0) {
        element.style.top = '0px';
      } else if (wScrollDiff > 0) {
        element.style.top = (elTop > 0 ? 0 : elTop) + 'px';
      } else if (wScrollDiff < 0) {
        element.style.top = (Math.abs(elTop) > elHeight ? -elHeight : elTop) + 'px';
      }
      wScrollBefore = wScrollCurrent;
    });
  }
});
